import axios from '../../Axios/Default';
// axios.defaults.baseURL = process.env.REACT_APP_URL_HUAWEI;
const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const DoLoginAdmin = (payload) => {
  const promise = axios.post("/admin/login", payload, config);
  return promise;
};

export const DoRefreshTokenAdmin = (payload) => {
  const access_token = localStorage.getItem("access_token");
  axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
  const promise = axios.post("/admin/refresh-token", payload, config);
  return promise;
};


export const doSaveAdmin = (payload) => {
  const promise = axios.post("/admin/v1/add-admin" , payload, config);
  return promise;
}


export const doUpdateAdmin = (payload, id) => {
  const promise = axios.put("/admin/v1/change-status/"+id , payload, config);
  return promise;
}


export const doDeleteAdmin = (id) => {
  const promise = axios.delete("/admin/v1/delete/"+id , [], config);
  return promise;
}

export const doDeleteUser = (id) => {
  const promise = axios.delete("/admin/user/delete/"+id , [], config);
  return promise;
}


export const doDeletePLTS = (id) => {
  const promise = axios.delete("/admin/set-station/delete/"+id , [], config);
  return promise;
}